import { CartItem, Charge } from "../../../cart/cart";
import { FulfillmentRequest } from "../../fulfillments/models/fulfillment-request.model";
import { RentalItemState } from "./rental-item-state.model";
import { InventoryItem } from "../../../inventory/inventory";
import { Activity } from "../../../activity/activity";
import { GpsInformation } from "../../models/gps-information.model";
import { Utilization } from "../../models/utilization.model";
import { RentalRequest } from "./rental-request.model";

export class RentalRequestItem {
  id: string;
  coverPhoto?: string;
  customerAssetId: string;
  make: string;
  model: string;
  year: string;
  usage: string;
  location: string;
  inventoryId: string;
  inventoryItem: InventoryItem;
  inventoryItemSummary: InventoryItem;
  rubblAssetId: string;
  ownerId: string;
  ownerAccount: string;
  jobStartDate: string;
  jobEndDate: string;
  duration: string | number;
  jobDuration: number;
  primaryType: string;
  total: number;
  subTotal: number;
  attachments: RentalRequestAttachment[];
  chargeSummary: Charge[];
  monthlySummary: Charge[];
  fulfillmentRequest: FulfillmentRequest;
  rentalStage: string;
  returnRequested: boolean;
  rentalItemState: RentalItemState;
  status: string;
  serialNumber: string;
  poJobNumber: string;
  returnFulfillmentRequested: boolean;
  statusData: RentalItemStatusData;
  imageThumbnail: string;
  hubSpotTicketId: string;
  activities: Activity[];
  rentalTerm: "day" | "week" | "month";
  gpsSerialNumber: string;
  hubSpotTicketStatus: string;
  //next are front end only
  cartItem: CartItem;
  chargesDropdownItems: any;
  utilizations: Utilization[];
  latestUtilization: Utilization;
  gpsInformations: GpsInformation[];
  latestGpsInformation: GpsInformation;
  rentalRequest: RentalRequest;
  gpsIcons: string;
}

export class RentalRequestAttachment {
  position: string;
  title: string;
  price: number;
  displayName: string;
  inventoryItemId: string;
  catalogId: string;
  primaryType: string;
}

export class RentalItemStatusData {
  status: string;
  bannerIcon: string;
  bannerMessage: string;
  showStartReturn: boolean;
  disableStartReturn: boolean;
}
